/**
 * @param {Picture} picture
 *
 * @return {String}
 */
export default function getPictureYoutubeSrc(picture) {
  const resultUrl = new URL(process.env.VUE_APP_YOUTUBE_EMBED_SRC + picture.srcNumber)

  resultUrl.searchParams.set('enablejsapi', '1')
  resultUrl.searchParams.set('version', '3')
  resultUrl.searchParams.set('playerapiid', 'ytplayer')

  return resultUrl.href
}
